var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaloncomunal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512,97.5A22.52,22.52,0,0,0,489.5,75H391V43.71A22.5,22.5,0,0,0,383.5,0h-255A22.5,22.5,0,0,0,121,43.72V75H22.5A22.5,22.5,0,0,0,15,118.71V459.5a7.5,7.5,0,0,0,7.5,7.5H166l-42,31.5a7.5,7.5,0,0,0,4.5,13.5h255a7.5,7.5,0,0,0,4.5-13.5L346,467H489.5a7.5,7.5,0,0,0,7.5-7.5V118.71A22.54,22.54,0,0,0,512,97.5ZM391,120h91V375H391ZM128.5,15h255a7.5,7.5,0,0,1,0,15h-225a7.5,7.5,0,0,0,0,15H376V452H361V292.5a7.5,7.5,0,0,0-7.5-7.5h-195a7.5,7.5,0,0,0-7.5,7.5V452H136V37.5a7.5,7.5,0,0,0-7.5-7.5,7.5,7.5,0,0,1,0-15Zm135,437V360H316v92ZM196,452V360h52.5v92ZM323.5,345h-135a7.5,7.5,0,0,0-7.5,7.5V452H166V300H346V452H331V352.5A7.5,7.5,0,0,0,323.5,345ZM121,120V375H30V120ZM22.5,90H121v15H22.5a7.5,7.5,0,0,1,0-15ZM30,390h91v62H30ZM361,497H151l40-30H321Zm30-45V390h91v62Zm98.5-347H391V90h98.5a7.5,7.5,0,0,1,0,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,240h46a7.5,7.5,0,0,0,7.5-7.5v-90a7.5,7.5,0,0,0-7.5-7.5h-46a7.5,7.5,0,0,0-7.5,7.5v90A7.5,7.5,0,0,0,52.5,240ZM60,150H91v75H60Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.5,135h-46a7.5,7.5,0,0,0-7.5,7.5v90a7.5,7.5,0,0,0,7.5,7.5h46a7.5,7.5,0,0,0,7.5-7.5v-90A7.5,7.5,0,0,0,459.5,135ZM452,225H421V150h31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,360h46a7.5,7.5,0,0,0,7.5-7.5v-90a7.5,7.5,0,0,0-7.5-7.5h-46a7.5,7.5,0,0,0-7.5,7.5v90A7.5,7.5,0,0,0,52.5,360ZM60,270H91v75H60Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.5,255h-46a7.5,7.5,0,0,0-7.5,7.5v90a7.5,7.5,0,0,0,7.5,7.5h46a7.5,7.5,0,0,0,7.5-7.5v-90A7.5,7.5,0,0,0,459.5,255ZM452,345H421V270h31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,103.35h-46a7.5,7.5,0,0,0-7.5,7.5v90a7.5,7.5,0,0,0,7.5,7.5h46a7.5,7.5,0,0,0,7.5-7.5v-90A7.5,7.5,0,0,0,221.62,103.35Zm-7.5,90h-31v-75h31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,105.35h-46a7.5,7.5,0,0,0-7.5,7.5v90a7.5,7.5,0,0,0,7.5,7.5h46a7.5,7.5,0,0,0,7.5-7.5v-90A7.5,7.5,0,0,0,338.62,105.35Zm-7.5,90h-31v-75h31Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaloncomunal);
export default __webpack_public_path__ + "static/media/saloncomunal.43eb76f4bead0ca646b35fdf1361059c.svg";
export { ForwardRef as ReactComponent };